/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

const template = [
  {
    id: uuidV4(),
    index: "1",
    title: "Tổng số cá nhân ủy quyền cho tổ chức, cá nhân trả thu nhập quyết toán thay",
    bg: false,
    spendId: 35,
    value: 0,
  },
  {
    id: uuidV4(),
    isTitle: false,
    index: "2",
    spendId: 36,
    value: 0,
    title: "Tổng số thuế thu nhập cá nhân đã khấu trừ",
  },
  {
    id: uuidV4(),
    spendId: 37,
    value: 0,
    title:
      "Trong đó: Số thuế thu nhập cá nhân đã khấu trừ tại tổ chức trước khi điều chuyển (trường hợp có đánh dấu vào chỉ tiêu [04])",
  },
  {
    id: uuidV4(),
    index: "3",
    spendId: 38,
    value: 0,
    title: "Tổng số thuế thu nhập cá nhân phải nộp",
  },
  {
    id: uuidV4(),
    index: "4",
    spendId: 39,
    value: 0,
    title:
      "Tổng số thuế thu nhập cá nhân được miễn do cá nhân có số thuế còn phải nộp sau ủy quyền quyết toán từ 50.000 đồng trở xuống",
  },
  {
    id: uuidV4(),
    index: "5",
    spendId: 40,
    value: 0,
    title: "Tổng số thuế thu nhập cá nhân còn phải nộp [40]=([38]-[36]-[39])>0",
  },
  {
    id: uuidV4(),
    index: "6",
    spendId: 41,
    value: 0,
    title: "Tổng số thuế thu nhập cá nhân đã nộp thừa [41]=([38]-[36]-[39])<0",
  },
];

function TaxPersonalTable02({ setFieldValue }) {
  const [data, setData] = useState(template);

  useEffect(() => {
    setFieldValue("valuesTableII", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value, type } = values;
    console.log({ id, name, value, type });
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value };
        }
        return item;
      })
    );
  };

  const isBg = (index) => {
    return [16, 17, 18, 21, 22, 23, 27, 28, 31].includes(index);
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box my={2}>
        <Typography variant="h5">II. NGHĨA VỤ QUYẾT TOÁN THAY CHO CÁ NHÂN</Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                STT
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Mã chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Đơn vị tính
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Số người/Số tiền
              </Td>
            </tr>
            {data.map((item) => {
              return (
                <tr key={item.id}>
                  {item.spendId !== 37 && (
                    <Td
                      rowSpan={item.spendId === 36 ? 2 : 1}
                      style={{
                        textAlign: "center",
                        background: item.spendId > 17 ? "#ddeff3" : "transparent",
                        fontWeight: isBg(item.spendId) ? "bold" : "400",
                      }}
                    >
                      {item.index}
                    </Td>
                  )}
                  <Td
                    style={{
                      textAlign: "left",
                      maxWidth: 400,
                      background: item.spendId > 17 ? "#ddeff3" : "transparent",
                      fontWeight: isBg(item.spendId) || item.index === "1" ? "bold" : "400",
                    }}
                  >
                    {item.title}
                  </Td>
                  <Td
                    style={{
                      textAlign: "center",
                      background: item.spendId > 17 ? "#ddeff3" : "transparent",
                      fontWeight: "bold",
                    }}
                  >
                    [{item.spendId}]
                  </Td>
                  <Td
                    style={{
                      textAlign: "center",
                      background: item.spendId > 17 ? "#ddeff3" : "transparent",
                    }}
                  >
                    {item.spendId > 20 ? "VNĐ" : "Người"}
                  </Td>
                  <Td
                    style={{
                      textAlign: "right",
                      paddingRight: item.spendId > 17 ? 20 : 8,
                      background: item.spendId > 17 ? "#ddeff3" : "transparent",
                      fontWeight: isBg(item.spendId) ? "bold" : "400",
                    }}
                  >
                    {item.spendId > 17 ? (
                      0
                    ) : (
                      <InputTable
                        id={item.id}
                        name="value"
                        value={item.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

export default memo(TaxPersonalTable02);

function InputTable(props) {
  const { id, onChange, type = "text", name, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
  }
  return (
    <input
      type={type}
      name={name}
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
